export default {
  address: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
  bank: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank',
  legal: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party',
  legalById: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party',
};
